// Autogenerated by `yarn version-file`. DO NOT EDIT
export var VERSION = '1.15.1';
//# sourceMappingURL=version.js.map